import React, { useEffect, useState } from "react";
import { CrossIcon, SettingMenuIcon } from "../common/Icon";
import { Link, useLocation } from "react-router-dom";
const SettingsSidebar = () => {
  const [settingsTab, setSettingsTab] = useState("myAccount");
  const [showSettingData, setShowSettingData] = useState(false);
  useEffect(() => {
    if (showSettingData) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showSettingData]);
  const location = useLocation();
  // OVERLAY BEHIND MOBILENAV
  const overLayHidden = () => {
    setShowSettingData(!showSettingData);
  };
  return (
    <>
      <div
        className={`w-full md:w-[146px] xl:max-w-[146px] 3xl:w-[90%] rounded-r-[16px] md:rounded-none 3xl:max-w-[100%] flex flex-col bg-white justify-between duration-200 absolute md:static ${
          showSettingData
            ? "left-0 bg-white z-50 h-full top-0 max-w-[200px] pl-2"
            : "left-[-980px]"
        } `}>
        <button
          aria-label="Closelink"
          className=" md:hidden setting-data-cross-icon absolute right-[10px] top-2"
          onClick={() => setShowSettingData(false)}>
          <CrossIcon />
        </button>
        <div className="flex flex-col items-start mt-10 md:mt-0 pr-[10px] md:pr-0">
          <Link
            to="/setting/my-account"
            onClick={() => {
              setSettingsTab("myAccount");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              // location.path.includes("myAccount")
              location.pathname.includes("/my-account")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            My Account
          </Link>
          <Link
            to="/setting/income-goals"
            onClick={() => {
              setSettingsTab("incomeGoals");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/income-goals")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Income goals
          </Link>
          <Link
            to="/setting/company"
            onClick={() => {
              setSettingsTab("company");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/company")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Company
          </Link>
          <Link
            to="/setting/sharing"
            onClick={() => {
              setSettingsTab("sharing");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/sharing")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Sharing
          </Link>
          <Link
            to="/setting/contact"
            onClick={() => {
              setSettingsTab("contact");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/contact")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Contact
          </Link>
          <Link
            to="/setting/payment-method"
            onClick={() => {
              setSettingsTab("paymentMethods");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/payment-method")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Payment methods
          </Link>
          <Link
            to="/setting/billing-information"
            onClick={() => {
              setSettingsTab("billingInformation");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/billing-information")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Billing Information
          </Link>
          <Link
            to="/setting/terms-condition"
            onClick={() => {
              setSettingsTab("termsConditions");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/terms-condition")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Terms & Conditions
          </Link>
          <Link
            to="/setting/privacy-policy"
            onClick={() => {
              setSettingsTab("privacyPolicy");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/privacy-policy")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            Privacy Policy
          </Link>
          <Link
            to="/setting/about-us"
            onClick={() => {
              setSettingsTab("aboutUs");
              setShowSettingData(false);
            }}
            className={` w-full text-start text-sm 3xl:text-base font-normal text-black py-[9px] px-[10px] border-b border-solid border-[rgba(0,_0,_0,_0.10)] ${
              location.pathname.includes("/about-us")
                ? " bg-[rgba(111,_106,_248,_0.12)] rounded-md border-transparent "
                : ""
            } `}>
            About Us
          </Link>
        </div>
        <Link
          to="/"
          className="text-sm 3xl:text-base font-normal text-[#FF0000] border-none text-start mb-3 inline-block hover:text-primary duration-200">
          Sign Out
        </Link>
      </div>
      <button
        className="h-[25px] md:hidden"
        onClick={() => {
          setShowSettingData(true);
        }}>
        <SettingMenuIcon />
      </button>
      <div
        onClick={overLayHidden}
        className={` fixed inset-0 min-h-full z-10  bg-black opacity-10 ${
          showSettingData ? "w-[100%] " : "hidden"
        }`}></div>
    </>
  );
};
export default SettingsSidebar;
